<template>
  <div :class="['FixedTwoButton', activeClass]">
    <div :class="['h-80', 'flex', 'items-center', 'justify-end', 'pr-20', 'FixedTwoButton-item', activeClass]" :style="{ width: width }">
      <!-- <ELButton size="small" :describe="leftButton" :myFunction="resetForm" />
      <ELButton size="small" :describe="rightButton" :myFunction="submitForm" type="primary" /> -->
      <slot />
      <!-- <el-button size="small" @click="resetForm">{{ leftButton }}</el-button>
      <el-button type="primary" size="small" @click="submitForm">{{ rightButton }}</el-button> -->
    </div>
    <div class="FixedTwoButton-content" :style="{ width: width }" />
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '30%',
    },
    activeClass: {
      type: String,
      default: '',
    },
    leftButton: {
      type: String,
      default: '重置',
    },
    rightButton: {
      type: String,
      default: '提交',
    },
  },
  methods: {
    resetForm() {
      this.$emit('resetForm')
    },
    submitForm() {
      this.$emit('submitForm')
    },
  },
}
</script>

<style lang="scss" scoped>
.FixedTwoButton {
  &-item {
    border-top: 1px solid #dedede;
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 999999;
    background-color: #fff;
  }
  &-content {
    height: 80px;
  }
}
</style>
